// Module
var code = "<div id=\"creating-demo-account\"><div class=\"gh-empty-module\"><div class=\"gh-empty-module-title\">{{ \"creating_your_demo_account\" | localize }}</div><div class=\"loading\"><div class=\"p-fixed\"><gh-indicator [gh-value]=\"indicators.loading\" gh-message=\"{{ 'loading' | localize }}\"></gh-indicator></div></div></div></div>";
// Exports
module.exports = code;